import theme from "@root/styles/theme";
import { makeStyles } from "tss-react/mui";

export const highlightColor = "#CCE6E1";
export const reviewerHighlightColor = "#D6E0F9";

export const blockquoteColor = "#F2F8F7";
export const reviewerBlockquoteColor = "#F4F7FD";

export const defaultMinHeight = 120;

type EditorStyleProps = {
  minHeight?: number;
  maxHeight?: number;
  blockquoteColor?: string;
};

export const useEditorStyles = makeStyles<EditorStyleProps>()(
  (_theme, { minHeight, maxHeight }) => ({
    textField: {
      width: "100%",
      minHeight: minHeight ?? defaultMinHeight,
      maxHeight,
      overflowY: "auto",
    },
    blockquote: {
      borderRadius: 4,
      border: "1px solid #ddd",
    },
    link: {
      color: `${theme.palette.customColor.cyan} !important`,
      cursor: "pointer",
    },
  }),
);

export default useEditorStyles;
